






















import { Component, Vue } from 'vue-property-decorator';
import { SearchResultItem } from '@/types/SearchResultItem';
import { Vessel } from '@/types/entities/Vessel';
import { DELETE_VESSEL } from '@/store/vessels';
import BoatPlaceholder from '@/svg/boat-placeholder.svg';
import ExclamationIcon from '@/svg/exclamation.svg';
import UiKitModal from '@/components/UiKit/UiKitModal.vue';

@Component({
  components: { UiKitModal, BoatPlaceholder, ExclamationIcon }
})
export default class ConfirmVesselDeletingModal extends Vue {
  protected vesselId: string;
  protected isError: boolean = false;

  public open(vessel: SearchResultItem<Vessel>) {
    this.vesselId = vessel.id;

    this.$modal.show('ConfirmVesselDeletingModal');
  }

  protected deleteVessel() {
    this.$store
      .dispatch(DELETE_VESSEL, this.vesselId)
      .then(() => this.$router.push({ name: 'marketplace.listings' }))
      .catch(() => this.isError = true);
  }
}
